import axiosCall from './interceptor';
import URL from '../helper';

export const createNewFolder = async data => {
  const url = `${URL.BASE_URL}folder`;
  let response = await axiosCall('post', url, data);
  return response.data;
};

export const getallFolder = async (isEmail = false, isShortMessage = false, includeElements = true, id, elementType) => {
  let payload = {
    includeElements
  };
  if (isEmail) { payload.elementType = 'emailTemplate'; }
  else if (isShortMessage) { payload.elementType = 'message'; }
  else if (elementType === "emailTemplate") { payload.elementType = "email" }
  else if(elementType) { payload.elementType = elementType}
  else{ payload.elementType = 'userTemplate';}
  if (id) { payload.rgroup = id; }
  
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}folder?includeDeleted=false&${searchParam.toString()}`;

  let response = await axiosCall('get', url);
  return response.data;
};

export const deleteFolder = async payload => {
  const url = `${URL.BASE_URL}folder?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const updateFolder = async data => {
  const url = `${URL.BASE_URL}folder`;
  let response = await axiosCall('put', url, data);
  return response.data;
};

export const addFolderElement = async data => {
  const url = `${URL.BASE_URL}folderelement `;
  let response = await axiosCall('post', url, data);
  return response.data;
};

export const deleteFolderElement = async payload => {
  const url = `${URL.BASE_URL}folderelement?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};
